var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('titulo-permissao',{attrs:{"titulo":_vm.$t('ADMIN.PERMISSOES_PERFIL') + `: ` + _vm.item.nome}}),_c('tabela',{attrs:{"permissoes":_vm.item.permissoes},on:{"salvar":_vm.salvarPermissao}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }